import { CountrySubdivisionCityFieldClass } from './component/CountrySubdivisionCityFieldClass';
import { refs } from '@descope-ui/theme-input-wrapper';

const vars = CountrySubdivisionCityFieldClass.cssVarList;

const countrySubdivisionCityField = {
  [vars.hostWidth]: refs.width,
  [vars.hostDirection]: refs.direction,
  [vars.flexDirection]: 'column',
  [vars.flexGap]: '0.5em',
  [vars.itemAlignment]: 'stretch',
  [vars.itemFlexGrow]: '0',
  [vars.itemWidth]: 'auto',

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },

  _horizontal: {
    [vars.flexDirection]: 'row',
    [vars.itemFlexGrow]: '1',
  },
};

export default countrySubdivisionCityField;
export { vars };
